var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VSelect',_vm._b({attrs:{"value":_vm.selected,"items":_vm.devices,"label":_vm.$t('headers.device'),"hint":_vm.$t('form.device_display')},on:{"input":function (e) { return _vm.$emit('input', e); }}},'VSelect',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }